@if (roleListConfig.list) {
    <curafida-card
        (setActionButton)="changeRole()"
        [actionButtons]="rolesActionButtons"
        [areButtonsVisible]="!isEditEnabled()"
        [disabled]="!hasRightToModifyUser() || isOwnDetails()"
        [title]="'USER.ROLLE.PLURAL'"
        class="full-width no-left-right-margin">
        <ion-card-content>
            <curafida-table
                [isLoading]="loadingProcess"
                [listTableConfig]="roleListConfig"></curafida-table>
        </ion-card-content>
    </curafida-card>
}
